import { render, staticRenderFns } from "./industryApplication.vue?vue&type=template&id=04222920&scoped=true&"
import script from "./industryApplication.vue?vue&type=script&lang=js&"
export * from "./industryApplication.vue?vue&type=script&lang=js&"
import style0 from "./industryApplication.vue?vue&type=style&index=0&id=04222920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04222920",
  null
  
)

export default component.exports